<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import state from "@/constants/state.js";
import indexJs from "@/store/index.js";
import types from "@/constants/types";
import login from "@/api/login.js";
import { banBackSpace } from "@/constants/banBackSpace.js";

export default {
  name: "App",
  mounted() {
    window.addEventListener("beforeunload", this.saveState);
    //阻止backspace键退出上一层
    document.onkeypress = banBackSpace;
    document.onkeydown = banBackSpace;
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.saveState);
  },
  methods: {
    saveState() {
      let { userInfo, userBindInfo, students, teachers, questionList, getExamPaperPositions, routermess } = this.$store.state;
      let simpleState = {
        userInfo,
        userBindInfo,
        students,
        teachers,
        questionList,
        getExamPaperPositions,
        routermess
      };
      sessionStorage.setItem("state", JSON.stringify(simpleState));
    }
  }
};
</script>
<style>
#app {
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
  min-width: 980px;
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  vertical-align: top;
  border: none;
}

* {
  padding: 0;
  margin: 0;
}

.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}

table {
  margin: 0;
}

::-webkit-scrollbar-thumb:horizontal {
  width: 4px;
  background-color: #cccccc;
}

::-webkit-scrollbar-track-piece {
  background-color: #fff;
  /*滚动条的背景颜色*/
  border-radius: 0;
  -webkit-border-radius: 0;
  /*滚动条的圆角宽度*/
}

::-webkit-scrollbar {
  width: 8px;
  /*滚动条的宽度*/
  height: 8px;
  /*滚动条的高度*/
}

::-webkit-scrollbar-thumb:vertical {
  width: 4px;
  background-color: #cccccc;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}

/* .el-tooltip__popper.is-light {
  border-color: #aaa;
  color: #999;
} */

/* tooltip三角箭头部分 */
.el-tooltip__popper .popper__arrow {
  /* 上方箭头 */
  border-top-color: #fff !important;
  /* 下方箭头 */
  border-bottom-color: #fff !important;
}

.el-tooltip__popper .popper__arrow:after {
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
}

/* tooltip主体部分 */
.el-tooltip__popper {
  /*padding:0 !important;
  // border-radius: 4px !important;*/
  border-color: #e6e6e6 !important;
  box-shadow:
    0px 0px 6px rgba(0, 0, 0, 0.13) !important;
}
</style>
<style lang="less">@import "./common/font/font.css";</style>



// WEBPACK FOOTER //
// src/App.vue